<template>
    <div>
        <a-card :bordered="false" :bodyStyle="tstyle">
            <div class="table-page-search-wrapper" v-if="hasPerm('baDatadictDetail:page')">
                <a-form layout="inline">
                    <a-row :gutter="48">
                        <a-col :md="8" :sm="24">
                            <a-form-item label="姓名">
                                <a-input v-model="queryParam.drName" allow-clear placeholder="请输入医生姓名" />
                            </a-form-item>
                        </a-col>
                        <a-col :md="8" :sm="24">
                            <a-form-item label="日期">
                                <a-range-picker @change="onChangeutstamp" />
                            </a-form-item>
                        </a-col>
                        <a-col :md="8" :sm="24">
                            <a-form-item label="号源类别">
                                <!-- <a-input v-model="queryParam.useflag" allow-clear placeholder="请输入是否启用（0:禁用，1:启用）" /> -->
                                <a-select v-model="queryParam.resourceType" placeholder="请选择号源类别">
                                    <a-select-option value="0">图文问诊</a-select-option>
                                    <a-select-option value="1">健康咨询</a-select-option>
                                    <a-select-option value="2">视频问诊</a-select-option>
                                    <a-select-option value="3">电话咨询</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="8" :sm="24">
                            <span class="table-page-search-submitButtons">
                                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
        </a-card>
        <a-card :bordered="false">
            <s-table ref="table" :columns="columns" :data="loadData" :alert="options.alert"
                :rowKey="(record) => record.sourceId" :rowSelection="options.rowSelection">



                <span slot="resourceType" slot-scope="text, record">
                    {{ record.resourceType == '0' ? '图文问诊' : record.resourceType == '1' ? '健康咨询' : record.resourceType
                    == '2' ? '视频问诊' :  record.resourceType  == '3' ? '电话咨询' :'' }}
                </span>
                <span slot="regState" slot-scope="text, record">
                    {{ record.regState == -1 ? '停诊' : record.regState == 0 ? '无号' : record.regState == 1 ? '可挂' : '' }}
                </span>
                <span slot="regType" slot-scope="text, record">
                    {{ record.regType == '1' ? '专家号' : '普通号' }}
                </span>



                <span slot="action" slot-scope="text, record">
                    <a v-show="record.regState == 0"></a>
                    <a v-show="record.regState == 1" @click="stopSource(record , -1)">停用</a>
                    <a v-show="record.regState == -1" @click="stopSource(record, 1)">恢复</a>
                    <a v-show="record.regState == 1" @click="showSource(record)" style="margin-left: 10px;">修改号源</a>
                </span>

            </s-table>
        </a-card>
        <!-- 修改号源数量弹框 -->
        <a-modal v-model="editSource" :width="600" title="修改号源数量" :maskClosable="false" @cancel="handleHideSource">
            <template slot="footer">
                <a-button key="back" @click="handleHideSource">
                    取消
                </a-button>
                <a-button key="ok" @click="fn_editSource">
                    修改
                </a-button>
            </template>
            <a-row :gutter="24" style="margin-bottom: 10px;">
                <a-form-item label="号源数量" :labelCol="{ xs: { span: 24 }, sm: { span: 4 } }" style="margin-bottom:10px;" :wrapperCol="{ xs: { span: 24 }, sm: { span: 20 } }">
                    <a-input style="width:260px" v-model="mount" allow-clear placeholder="请输入号源数量" /> &nbsp;&nbsp;
                </a-form-item>
            </a-row>
        </a-modal>
    </div>
</template>
<script>
import { STable, XDown } from '@/components'
import moment from 'moment'
import { numSourceDetailPage , Deactivate , baSourceEdit } from '@/api/modular/interhospital/numSource/numSourceManage'
export default {
    components: {
        STable,
        XDown
    },
    data() {
        return {
            // 高级搜索 展开/关闭
            advanced: false,
            // 查询参数
            queryParam: {},
            // 表头
            columns: [
                {
                    title: '号源日期',
                    align: 'center',
                    dataIndex: 'date'
                },
                {
                    title: '科室',
                    align: 'center',
                    dataIndex: 'deptName'
                },
                {
                    title: '医生姓名',
                    align: 'center',
                    dataIndex: 'drName'
                },
                {
                    title: '剩余数量',
                    align: 'center',
                    dataIndex: 'mount'
                },
                {
                    title: '具体时间',
                    align: 'center',
                    dataIndex: 'detailTime'
                },
                {
                    title: '号源类型',
                    align: 'center',
                    dataIndex: 'regType',
                    scopedSlots: { customRender: 'regType' },
                },
                {
                    title: '号源类别',
                    align: 'center',
                    dataIndex: 'resourceType',
                    scopedSlots: { customRender: 'resourceType' },
                },
                {
                    title: '挂号费',
                    align: 'center',
                    dataIndex: 'registerFee',
                    scopedSlots: { customRender: 'registerFee' },
                },
                {
                    title: '状态',
                    align: 'center',
                    dataIndex: 'regState',
                    scopedSlots: { customRender: 'regState' },
                },
            ],
            tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
            // 加载数据方法 必须为 Promise 对象
            loadData: parameter => {
                return numSourceDetailPage(Object.assign(parameter, this.switchingDate())).then((res) => {
                    return res.data
                })
            },
            selectedRowKeys: [],
            selectedRows: [],
            options: {
                alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
                rowSelection: {
                    selectedRowKeys: this.selectedRowKeys,
                    onChange: this.onSelectChange
                }
            },
            mount: 0, // 号源数量
            editSource: false, // 修改号源数量弹框
            editRecord: {}, // 修改号源数量弹框数据
            
        }
    },
    created() {
        this.columns.push({
            title: '操作',
            width: '150px',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' }
        })
    },
    methods: {
        moment,
        
        /**
         * 查询参数组装
         */
        switchingDate() {
            const queryParamctstamp = this.queryParam.ctstampDate
            if (queryParamctstamp != null) {
                this.queryParam.ctstamp = moment(queryParamctstamp).format('YYYY-MM-DD')
                if (queryParamctstamp.length < 1) {
                    delete this.queryParam.ctstamp
                }
            }
            const queryParamutstamp = this.queryParam.utstampDate
            if (queryParamutstamp != null) {
                this.queryParam.utstamp = moment(queryParamutstamp).format('YYYY-MM-DD')
                if (queryParamutstamp.length < 1) {
                    delete this.queryParam.utstamp
                }
            }
            const obj = JSON.parse(JSON.stringify(this.queryParam))
            return obj
        },
        onChangectstamp(date, dateString) {
            this.ctstampDateString = dateString
        },
        onChangeutstamp(date, dateString) {
            this.queryParam.startDate = dateString[0];
            this.queryParam.endDate = dateString[1];

        },

        stopSource(record,state) {
            let params = {
                sourceId: record.sourceId,
                state,
            }
            Deactivate(params).then(res => {
                console.log(res)
                if (res.code == 200) {
                    this.$message.success('操作成功');
                    this.handleOk();
                } else {
                    this.$message.error(res.message);
                    this.handleOk();
                }
            })
        },
        fn_editSource() {
            let params = {
                sourceId : this.editRecord.sourceId,
                mount : this.mount, // 号源数量
            }
            baSourceEdit(params).then(res => {
                console.log(res)
                if (res.code == 200) {
                    this.$message.success('修改成功');
                    this.editSource = false;
                    this.handleOk();
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        showSource(record) {
            this.editSource = true;
            this.editRecord = record;
            this.mount = record.mount; // 号源数量
        },
        handleHideSource() {
            this.editSource = false;
        },
        handleOk() {
            this.$refs.table.refresh()
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selectedRowKeys = selectedRowKeys
            this.selectedRows = selectedRows
        }
    }
}
</script>
<style lang="less">
.table-operator {
    margin-bottom: 18px;
}

button {
    margin-right: 8px;
}
</style>
